module.exports = __webpack_public_path__ + "img/22-portuguese.ea2f4f59.svg";